<template>
  <div>
    <form>
      <v-select
        v-model="form.nepravdive_zavadzajuce"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.nepravdive_zavadzajuce"
        label="Nepravdivé/zavádzajúce informácie"
        name="Nepravdivé/zavádzajúce informácie"
        :error-messages="errors.collect('Nepravdivé/zavádzajúce informácie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('nepravdive_zavadzajuce')"
      />

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-title>
            <span class="headline">Charakteristika</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Zdroj</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.zdroj"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Príklad</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.priklad"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Poznámka</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.poznamka"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: []
    },

    form: {
      id: null,
      nepravdive_zavadzajuce: "",
      skore: 0
    },
    craItem: {},

    selects: {
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch"
      ]
    },

    manual: {
      nepravdive_zavadzajuce: {
        nazov: "Nepravdivé/zavádzajúce informácie",
        priklad: [],
        poznamka: [],
        zdroj: [],
        charakteristika: [
          "Ak ktorýkoľvek z hodnotiteľov zistí akýkoľvek rozpor (napr. klamstvo, zavádzanie...) v údajoch poskytnutých odsúdeným,  túto skutočnosť oznámi prípadovému manažérovi."
        ]
      }
    }
  }),

  computed: {},

  created() {
    this.getNahodneOverenie();
  },

  methods: {
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    clear() {
      this.form.id = null;
      this.form.nepravdive_zavadzajuce = "";
      this.skore = 0;
    },
    getNahodneOverenie() {
      apiService.getNahodneOverenie(this.$route.params.id).then(response => {
        this.form = response;
      });
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.craItem = response;
      });
    },
    updateItem() {
      apiService.updateNahodneOverenie(this.form, this.$route.params.id).then(
        () => {
          this.snackbar_saved = true;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
    openItem() {
      apiService
        .updateNahodneOverenie(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updateNahodneOverenie(this.form, this.$route.params.id)
              .then(
                response => {
                  this.snackbar_saved = true;
                  this.form = response;
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    }
  }
};
</script>